// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"NewCheckbox_checkbox__2vGJ8","checkmark":"NewCheckbox_checkmark__1-hCV","filterCheckbox":"NewCheckbox_filterCheckbox__1r1Vr"};